import React, { useEffect, useState } from 'react'
import { Table } from 'semantic-ui-react'
import Loader from '../../components/Loader';
import Heading from '../../components/Heading';
import user from '../../store/user';
import ButtonContainer from '../../components/ButtonContainer';
import Button from '../../components/Button';
import moment from 'moment';

import FromToDatePicker from '../../components/FromToDatepicker';

import { preRejectReport } from '../../services/preRejectReport';

const filtersInitialState = {
    to: moment().toDate(),
    from: moment().subtract(1, 'M').toDate()
}

function PreRejectReport() {
    const [adminId, setAdminId] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [from, setFrom] = useState(filtersInitialState.from)
    const [to, setTo] = useState(filtersInitialState.to)
    const [total, setTotal] = useState({
        total: 0,
        actionTaken: 0,
        actionNotTaken: 0,
    });


    useEffect(() => {

        (async () => {
            const profile = await user.getProfile();
            setAdminId(profile.id);
            fetchData(profile.id);
            console.log(profile);    
        })()

    }, []);

    async function fetchData(adminId) {
        setIsLoading(true);
        const res = await preRejectReport(adminId, {
            from: from,
            to: to
        })

        let t = 0, aT = 0, aNT = 0;
        const data = Object.keys(res.data.data).map(k => {
            const i = res.data.data[k];

            t += i.total;
            aT += i.actionTaken;
            aNT += i.actionNotTaken;

            return {
                date: k,
                ...i
            }
        })
        setData(data || []);
        setTotal({
            total: t,
            actionTaken: aT,
            actionNotTaken: aNT
        });
        setIsLoading(false);
    }

    return (
        <div className="pre-reject-report">
            <div className="pro-lead-gen-heading">
                <Heading text='Sent To CS Report' />
            </div>

            <div className='filter-container'>
                <ButtonContainer heading='Filter By Date: '>
                    <li key="postDate">
                        <FromToDatePicker
                            name="date"
                            startDate={from}
                            endDate={to}
                            handleChangeStart={(e) => setFrom(e)}
                            handleChangeEnd={(e) => setTo(e)}
                        />
                    </li>
                    <li>
                        <Button
                        text='Filter'
                        skin='dark'
                        clickButton={() => fetchData(adminId)}
                        disabled={!from || !to} 
                        />
                    </li>
                </ButtonContainer>
                
        </div>

            <br />
            {
                isLoading ? <Loader /> :
                    <div>
                        <Table fixed selectable className="mailers-table">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Date</Table.HeaderCell>
                                    <Table.HeaderCell>Mail Sent to CS</Table.HeaderCell>
                                    <Table.HeaderCell>Action via CS Team</Table.HeaderCell>
                                    <Table.HeaderCell>Not addressed by Sales/CS team</Table.HeaderCell>
                                    <Table.HeaderCell>Action via CS Team (%)</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>

                                {
                                    data.map((item, i) => {
                                        return (
                                            <Table.Row key={i}>
                                                <Table.Cell>{item.date}</Table.Cell>
                                                <Table.Cell>{item.total}</Table.Cell>
                                                <Table.Cell>{item.actionTaken}</Table.Cell>
                                                <Table.Cell>{item.actionNotTaken}</Table.Cell>
                                                <Table.Cell>{((item.actionTaken / item.total) * 100).toFixed(2)}</Table.Cell>
                                            </Table.Row>
                                        )
                                    })
                                }

                                <Table.Row>
                                    <Table.Cell>Total</Table.Cell>
                                    <Table.Cell>{total.total}</Table.Cell>
                                    <Table.Cell>{total.actionTaken}</Table.Cell>
                                    <Table.Cell>{total.actionNotTaken}</Table.Cell>
                                    <Table.Cell>{((total.actionTaken / total.total) * 100).toFixed(2)}</Table.Cell>
                                </Table.Row>

                            </Table.Body>
                        </Table>
                    </div>
            }
        </div>
    )

}

export default PreRejectReport;